import { Snowflake } from 'lucide-react';
import { Label } from '@/components/atoms/texts/label';
import { InterestsHoldPeriod } from '@/components/molecules/InterestsHoldIcon';
import PrintWarningMessage from '@/components/organisms/feedback/PrintWarningMessagee';

export default function InterestsHoldActiveWarning({ hold, className }) {
    if (!hold) return null;

    return (
        <PrintWarningMessage
            className={className}
            isComponent
            warning={
                <div className="flex flex-wrap items-center gap-firstDegree">
                    <Snowflake className="h-4 w-4 text-informative-foreground" />
                    <Label fontWeight="semibold" message="consultants.statement.interestsHolds.activeHoldWarning" />
                    <InterestsHoldPeriod hold={hold} />
                    {hold.comment && <Label size="small" color="disabled">{hold.comment}</Label>}
                </div>
            }
        />
    );
}
